<template> 

  <div class="container pt-4 mb-5">

    <b-button variant="light" :to="('/app/millionaire-mindset-generator/')">
      <span class="material-symbols-outlined align-middle">chevron_left</span>
      Wróć
    </b-button>

    <div>
      
      <b-row align-v="center">

        <b-col lg="12">
 
          <div class="mt-4">

            <div class="mt-3">

              <label>Wpisz ile zarabiasz rocznie:</label>

              <b-input-group>

                <b-form-input v-model="zarobki" size="lg" ref="zarobki" placeholder="np. 100 000 zł może to być kwota z PIT-A"></b-form-input>
                
              </b-input-group>
 
            </div>

            <div class="mt-3">

              <label>Napisz czym się zajmujesz i jakie masz kompetencje:</label>

              <b-input-group>

                <b-form-input v-model="zajecie" size="lg" ref="zajecie" placeholder="np. jestem specjalistą HR"></b-form-input>

              </b-input-group>

            </div>

            <div class="mt-3">

              <label>Wpisz ile dni w roku pracujesz?:</label>

              <b-input-group>

                <b-form-input v-model="dni" size="lg" ref="dni" placeholder="np. 230 dni (tyle średnio pracujemy w Polsce)."></b-form-input>

              </b-input-group>

            </div>

            <div class="mt-3">

              <label>Ile godzin dziennie pracujesz:</label>

              <b-input-group>

                <b-form-input v-model="godzin" size="lg" ref="godzin" placeholder="np. 8 godzin"></b-form-input>

              </b-input-group>

            </div>

            <div class="mt-3">

              <label>Wpisz kwotę dochodu pasywnego miesiecznie:</label>

              <b-input-group>

                <b-form-input v-model="kwota" size="lg" ref="kwota" placeholder="np. z najmu nieruchomości"></b-form-input>

              </b-input-group>

            </div>

          </div>

        </b-col>

      </b-row>
  
      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">
        
        </b-col>

        <b-col lg="6">

        <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
          Generuj
        </b-button> 

        </b-col>

      </b-row>



      <div class="mt-2" >
  
        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje treść <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Wygenerowana treść</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">
            
            <div class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;">

              <div v-if="result" v-html="result" class="pb-3 mb-3" style="border-bottom: 1px solid #ddd;"></div>

            </div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>
   
        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>   
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>
 
    </div>

  </div>

</template>

<script>

  export default {
    name: 'apxc',
    components: {
    },
    data() {
      return {
        isFinish: false,
        result: "",
        result2: "",
        selectedText: '',
        query: "",
        kwota: "",
        godzin: "",
        dni: "",
        zajecie: "",
        zarobki: "",
        finishContent: '',
        selectedSchema: null
      }
    },
    methods: {

      generateFinish: function() {

        if(!this.kwota) return false;
        if(!this.godzin) return false;
        if(!this.dni) return false;
        if(!this.zajecie) return false;
        if(!this.zarobki) return false;

        this.$refs.generatePost.disabled = true

        this.isFinish = true

        this.finishContent = ""
        this.result = ""

        var query = " Oblicz mi wartość godziny czasu pracy i podpowiedz co mogę zrobić żeby zwiększyć wartość tej godziny.\n" +
            "            Oto dane: rocznie zarabiam "+this.zarobki+" złotych, pracuję jako "+this.zajecie+" pracuję przez\n" +
            "            "+this.dni+" dni w roku po "+this.godzin+" godzin. Mój miesięczny dochód pasywny to\n" +
            "        "+this.kwota+". Miesięczny dochód pasywny pomnóż razy 12 i dodaj do rocznych zarobków." +
            "  Oblicz wartość mojej godziny czasu pracy,\n" +
            "            jaki procent stanowi dochód pasywny i stwórz mi pomysł na to jak mogę zwiększyć wartość\n" +
            "        tej godziny i poprawić ilość dochodu pasywnego.";

        query = query + "Używaj znaczników HTML zamiast markdown. Dozwolone znaczniki: Pogrubienie czyli <B></B>, i nowa linia <br/> . Zamiast znaczników nagłówków Hx użyj po prostu pogrubienia.";

        var doneText = "";

        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query, 'v': 'o1' }, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data
 
          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          doneText = data.result;

          this.finishContent = doneText;

          this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/>');


          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana treść"

        }).catch(function() {

          this.$refs.generatePost.disabled = false

         })
 
        
 
      },
 
      copyResults: function() {
 
        this.$refs.finishContent.style.display = "block";
        
        this.$refs.finishContent.focus();

        document.execCommand('copy');
         
        this.$refs.finishContent.style.display = "none"

        window.scrollTo(0, 0)

        this.$bvToast.toast('Treść została skopiowana do schowka', {
          title: 'Skopiowano',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })

      } 

    },
    computed: {
  
    },
    created() {

    },
    mounted() {

    },
    watch: {

    }

  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
  code { color: #4e82f7 !important; }
</style>